// ============================================================
// DatePicker
// ------------------------------------------------------------
// ปฏิทินเลือกวันที่แบบ พ.ศ. (เขียนเอง ไม่ได้ใช้ library)
//
// props
//   value     : ค่าเริ่มต้น "YYYY-MM-DD" (ค.ศ.)
//   onChange  : callback ได้ค่า "YYYY-MM-DD" (ค.ศ.) หรือ "" เมื่อกด clear
//   min / max : ช่วงวันที่ที่เลือกได้ (ค่าเริ่มต้น ±100 ปีจากวันนี้)
//   position  : "top" = เปิดปฏิทินขึ้นด้านบน (กันตกขอบจอ)
//   className / disabled : ส่งต่อไปที่ <input>
//
// หมายเหตุ: ช่องกรอกแสดงเป็น dd/mm/yyyy พ.ศ. แต่ค่าที่ส่งออกเป็น ค.ศ. เสมอ
// ============================================================

import React, { Component } from "react";

const MONTH_FULL = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
const WEEKDAY = ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."];

export default class DatePicker extends Component {
  state = {
    value: "", // วันที่ที่ถูกเลือกจริง (Date object) หรือ "" ถ้ายังไม่เลือก
    default: new Date(), // เดือน/ปี ที่ปฏิทินกำลังเปิดดูอยู่
    array_date: [], // ช่องวันที่ในเดือนที่เปิดดู (ช่องว่างข้างหน้าไว้จัดตำแหน่งวันในสัปดาห์)
    array_month: MONTH_FULL,
    array_year: [],
    showCalendar: false,
    min: new Date(new Date().setFullYear(new Date().getFullYear() - 100)),
    max: new Date(new Date().setFullYear(new Date().getFullYear() + 100)),
  };

  componentDidMount = () => {
    // สร้างรายการปีให้เลือก ย้อนหลัง/ล่วงหน้า 100 ปี
    const year = [];
    for (let i = -100; i < 100; i++) year.push(new Date().getFullYear() + i);
    this.setState({ array_year: year });

    if (this.props.value) this.setState({ default: new Date(this.props.value), value: new Date(this.props.value) });
    if (this.props.min) this.setState({ min: new Date(this.props.min) });
    if (this.props.max) this.setState({ max: new Date(this.props.max) });
    this.getDates();
  };

  // sync ค่าจากหน้าจอแม่ (เช่นกดล้างฟอร์ม แล้ว value กลายเป็นค่าว่าง)
  componentWillReceiveProps = (props) => {
    if (props.min) this.setState({ min: new Date(props.min) });
    if (props.max) this.setState({ max: new Date(props.max) });
    if (props.value) this.setState({ default: new Date(props.value), value: new Date(props.value) });
    else this.setState({ default: new Date(), value: "" });
  };

  // ส่งค่ากลับหน้าจอแม่เป็น "YYYY-MM-DD" (ค.ศ.) แล้วปิดปฏิทิน
  onChangeDate = (option) => {
    if (option === "") {
      this.props.onChange("");
    } else {
      this.props.onChange(Number(option.getFullYear()) + "-" + ("0" + (Number(option.getMonth()) + 1)).slice(-2) + "-" + ("0" + option.getDate()).slice(-2));
    }
    this.setState({ value: option, showCalendar: false });
  };

  // สร้างช่องวันที่ของเดือนที่กำลังเปิดดู
  getDates = () => {
    const dates = [];
    const date = new Date(this.state.default.getFullYear(), this.state.default.getMonth(), 1);
    // เติมช่องว่างหน้าวันที่ 1 ให้ตรงกับวันในสัปดาห์
    for (let d = 0; d < new Date(date).getDay(); d++) dates.push("");
    while (date.getMonth() === this.state.default.getMonth()) {
      dates.push(new Date(date).getDate());
      date.setDate(date.getDate() + 1);
    }
    this.setState({ array_date: dates });
  };

  // เลื่อนเดือนไปข้างหน้า/ถอยหลัง (step = 1 หรือ -1)
  moveMonth = (step) => {
    const date = this.state.default;
    date.setMonth(date.getMonth() + step);
    this.setState({ default: date });
    setTimeout(() => this.getDates(), 1);
  };

  // วันที่นี้อยู่ในช่วง min-max ที่เลือกได้ไหม
  inRange = (day) => {
    const d = new Date(this.state.default.getFullYear(), this.state.default.getMonth(), day);
    return d > this.state.min.getTime() && d < this.state.max.getTime();
  };

  // วันที่นี้คือวันที่ถูกเลือกอยู่ไหม
  isSelected = (day) => {
    const { value, default: viewing } = this.state;
    return value && day && value.getDate() === day && value.getMonth() === viewing.getMonth() && value.getFullYear() === viewing.getFullYear();
  };

  render() {
    const { showCalendar, value, default: viewing, array_date, array_month, array_year } = this.state;
    // ปุ่มเลื่อนเดือนจะจางลงเมื่อชนขอบของช่วงปีที่มีให้เลือก
    const atFirstMonth = viewing.getMonth() === 0 && viewing.getFullYear() === new Date().getFullYear() - 100;
    const atLastMonth = viewing.getMonth() === 11 && viewing.getFullYear() === new Date().getFullYear() + 99;

    return (
      <div className="w-100 position-relative" style={{ minHeight: 44 }}>
        {/* ฉากหลังโปร่งใส กดแล้วปิดปฏิทิน */}
        {showCalendar && <div style={{ bottom: 0, left: 0, top: 0, right: 0, backgroundColor: "#0000", zIndex: 1000, position: "fixed" }} onClick={() => this.setState({ showCalendar: false })}></div>}

        <div className="w-100">
          {/* ช่องกรอก แสดงเป็น dd/mm/yyyy พ.ศ. */}
          <input
            className={this.props.className + " pointer"}
            type="text"
            value={value ? ("0" + value.getDate()).slice(-2) + "/" + ("0" + (Number(value.getMonth()) + 1)).slice(-2) + "/" + (Number(value.getFullYear()) + 543) : ""}
            placeholder={this.state.placeholder ? this.state.placeholder : "dd/mm/yyyy"}
            onFocus={() => {
              // เปิดปฏิทินที่เดือนของค่าที่เลือกไว้ ถ้ายังไม่เลือกให้เปิดเดือนปัจจุบัน
              this.setState({ showCalendar: true, default: value ? new Date(value) : new Date() });
              setTimeout(() => this.getDates(), 10);
            }}
            disabled={this.props.disabled}
          />

          {showCalendar && (
            <div className="card rounded py-2 shadow position-absolute" style={{ zIndex: 1001, width: 300, marginTop: this.props.position === "top" ? -410 : 10 }}>
              {/* แถบหัว: เลื่อนเดือน + เลือกเดือน/ปี */}
              <div className="d-flex justify-content-between align-items-center">
                {atFirstMonth ? (
                  <span className="p-3 pointer text-light">{"<"}</span>
                ) : (
                  <span className="p-3 pointer" onClick={() => this.moveMonth(-1)}>
                    {"<"}
                  </span>
                )}
                {/* เดือน */}
                <select
                  className="wpx-100 border-0 select-none text-center"
                  onChange={(e) => {
                    const date = viewing;
                    date.setMonth(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => this.getDates(), 1);
                  }}
                  value={viewing ? viewing.getMonth() : ""}
                >
                  {array_month.map((item, index) => (
                    <option key={"option" + index} value={index}>
                      {item}
                    </option>
                  ))}
                </select>
                <label className="mb-0 pointer mx-2">พ.ศ.</label>
                {/* ปี (แสดงเป็น พ.ศ. แต่ค่าจริงเป็น ค.ศ.) */}
                <select
                  className="wpx-60 border-0 select-none text-center"
                  onChange={(e) => {
                    const date = viewing;
                    date.setFullYear(e.target.value);
                    this.setState({ default: date });
                    setTimeout(() => this.getDates(), 1);
                  }}
                  value={viewing ? viewing.getFullYear() : ""}
                >
                  {array_year.map((item, index) => (
                    <option key={"option" + index} value={item}>
                      {item + 543}
                    </option>
                  ))}
                </select>
                {atLastMonth ? (
                  <span className="p-3 pointer text-light">{">"}</span>
                ) : (
                  <span className="p-3 pointer" onClick={() => this.moveMonth(1)}>
                    {">"}
                  </span>
                )}
              </div>

              {/* หัวตารางวันในสัปดาห์ */}
              <div className="w-100 d-flex row mx-0">
                {WEEKDAY.map((item, index) => (
                  <div key={"weekday" + index} className="py-1 text-center" style={{ width: "14.28%" }}>
                    {" "}
                    {item}{" "}
                  </div>
                ))}
              </div>

              {/* ช่องวันที่ */}
              <div className="w-100 d-flex row mx-0" style={{ height: 220 }}>
                {array_date.map((item, index) => {
                  const selected = this.isSelected(item);
                  const enabled = this.inRange(item);
                  // คงคลาสเดิมทุกกรณี: เลือกอยู่ = พื้นน้ำเงิน, นอกช่วง = ตัวอักษรจาง, กดได้ = pointer
                  const className = ["py-1 text-center", enabled ? "pointer" : "", selected ? "bg-primary text-white" : "", "d-flex align-items-center justify-content-center", enabled ? "" : "text-light"]
                    .filter(Boolean)
                    .join(" ");
                  return (
                    <div
                      key={"date" + index}
                      className={className}
                      style={{ width: "14.28%" }}
                      onClick={() => {
                        if (enabled) this.onChangeDate(new Date(viewing.getFullYear(), viewing.getMonth(), item));
                      }}
                    >
                      {item}
                    </div>
                  );
                })}
              </div>

              {/* ปุ่มล้างค่า / วันนี้ */}
              <div className="d-flex justify-content-between px-2">
                <label className="pointer text-primary" onClick={() => this.onChangeDate("")}>
                  clear
                </label>
                <label className="pointer text-primary" onClick={() => this.onChangeDate(new Date())}>
                  To day
                </label>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
